import marked from 'marked';

export const getProp = ({ entry }, field) => entry.getIn(['data', field]);

const getFieldValue = ({ fieldsMetaData, field, type, config }, fieldId) => {
  // console.log('fieldsMetaData: ', fieldsMetaData);
  const pObj = fieldsMetaData.getIn([field, type, fieldId]);
  if (pObj) {
    const res = pObj.toJS();
    // Process markdown fields
    const typeFields = config.collections.find((e) => e.name === type).fields;
    const markdownFields = typeFields.filter((f) => f.widget === 'markdown');
    markdownFields.forEach((mField) => {
      const fieldName = mField.name;
      const fieldVal = res[fieldName];
      if (fieldVal) {
        res[fieldName] = marked(fieldVal);
      }
    });
    return res;
  }
  return null;
};
export const getPropRel = ({ entry, getAsset, fieldsMetaData, config }, field, type) => {
  const fieldId = entry.getIn(['data', field]).toJS();
  if (fieldId.length) {
    // console.log('fieldId: ', fieldId);
    return fieldId
      .map((itemId) => getFieldValue({ fieldsMetaData, getAsset, config, field, type }, itemId))
      .filter((item) => !!item);
  }
  return getFieldValue({ fieldsMetaData, getAsset, config, field, type }, fieldId);
};
export const getPropAsset = ({ entry, getAsset }, field) =>
  getAsset(entry.getIn(['data', field])).url;
export const getPropMarked = (...args) => {
  const markdown = getProp(...args);
  return markdown ? marked(markdown) : markdown;
};
